var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoordinates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0H4.5V6.75H6V0Z",
    fill: "#A3A9B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9H8.25V10.5H15V9Z",
    fill: "#A3A9B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9H2.25V10.5H0V9Z",
    fill: "#A3A9B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 8.25H3.75V11.25H6.75V8.25Z",
    fill: "#A3A9B9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12.75H6V15H4.5V12.75Z",
    fill: "#A3A9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoordinates);
export default __webpack_public_path__ + "static/media/coordinates.a2bfbf57940b17d6b2b34d046017f5db.svg";
export { ForwardRef as ReactComponent };